import { Outlet } from "react-router-dom";
import PageDepth2 from "../components/PageDepth2";
import styles from '../styles/Profile.module.css';
import data from '../data/data.json'
import classNames from "classnames/bind";
import PageTitle from "../components/PageTitle";

const cx = classNames.bind(styles);

//회사개요
export default function Profile() {

  const profileCategory = data.category.find(
    (category) => category.path === "profile"
  )

  return (
    <>
      <PageTitle title={profileCategory.label} image={profileCategory.image} />
      
      <PageDepth2 pagedepth2={profileCategory.children} />

      <Outlet />
    </>
  );
}